import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import {
  NgbModule,
  NgbPopoverModule,
  NgbTooltipModule,
} from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { translationChunksConfig } from '@spartacus/assets';
import { I18nModule, provideConfig } from '@spartacus/core';
import { CustomUserRegistrationModule } from 'src/app/custom-user-registration/custom-user-registration.module';
import { TermsConditionsModule } from '../terms-conditions/terms-conditions.module';
import { CheckoutComponent } from './checkout.component';
import { PaymentsDropdownComponent } from '../../components/payments-dropdown/payments-dropdown.component';
import { PaymentMethodComponent } from '../../components/payment-method/payment-method.component';

@NgModule({
  declarations: [CheckoutComponent],
  exports: [CheckoutComponent],

	imports: [
		CommonModule,
		NgbTooltipModule,
		NgSelectModule,
		ReactiveFormsModule,
		BrowserModule,
		FormsModule,
		CustomUserRegistrationModule,
		I18nModule,
		NgbPopoverModule,
		NgbModule,
		TermsConditionsModule,
		FontAwesomeModule,
		PaymentsDropdownComponent,
		PaymentMethodComponent
	],
  providers: [
    provideConfig({
      i18n: {
        backend: {
          loadPath: 'i18n-assets/{{lng}}/{{ns}}.json',
        },
        chunks: translationChunksConfig,
      },
      cmsComponents: {
        checkoutPage: {
          component: () =>
            import(
              '../terms-conditions/terms-conditions/terms-conditions.component'
            ).then((m) => m.TermsConditionsComponent),
        },
      },
    }),
  ],
})
export class CheckoutModule {}
